<app-dialog
    headerText="Manage Views"
    saveText="SAVE"
    cancelText="CANCEL"
    [body]="dialogBody"
    [validationFn]="isValid.bind(this)"
    (save)="onSave()">
</app-dialog>

<ng-template #dialogBody>
    <div class="manage-views-content">
        <div class="search-box">
            <input
                fd-form-control
                type="text"
                [(ngModel)]="searchTerm"
                placeholder="Search"
                i18n-placeholder="XFLD|Search placeholder@@manageViews.search"
            />
            <app-icon icon="search" class="search-icon"></app-icon>
        </div>

        <div class="views-table">
            <div class="table-header">
                <div class="col-view">
                    <span i18n="XTIT|View column header@@manageViews.viewColumn">VIEW</span>
                </div>
                <div class="col-default">
                    <span i18n="XTIT|Default column header@@manageViews.defaultColumn">DEFAULT</span>
                </div>
                <div class="col-created-by">
                    <span i18n="XTIT|Created by column header@@manageViews.createdByColumn">CREATED BY</span>
                </div>
                <div class="col-actions"></div>
            </div>

            <div class="table-body">
                <div *ngFor="let view of filteredViews; let i = index"
                     class="table-row"
                     [class.is-standard]="view.isSystem">
                    <div class="col-view">
                        <div *ngIf="!view.isSystem" class="view-name-wrapper">
                            <input
                                fd-form-control
                                type="text"
                                [(ngModel)]="view.name"
                                (ngModelChange)="onViewNameChanged(view)"
                                [disabled]="view.isSystem"
                                [class.is-error]="view.errorMessage"
                                [state]="view.errorMessage ? 'error' : 'default'"
                                class="view-name-input"
                            />
                            <fd-form-message type="error" *ngIf="view.errorMessage">
                                {{ view.errorMessage }}
                            </fd-form-message>
                        </div>
                        <span *ngIf="view.isSystem" class="view-name-text">{{ view.name }}</span>
                    </div>
                    <div class="col-default">
                        <fd-radio-button
                            [name]="'defaultView'"
                            [value]="view.name"
                            [(ngModel)]="defaultViewName"
                        >
                        </fd-radio-button>
                    </div>
                    <div class="col-created-by">
                        <span>{{ view.isSystem ? 'SAP' : 'You' }}</span>
                    </div>
                    <div class="col-actions">
                        <button
                            *ngIf="!view.isSystem"
                            fd-button
                            fdType="transparent"
                            class="delete-button"
                            (click)="onDeleteView(view)"
                            [title]="'Delete View'"
                            i18n-title="XTOL|Delete view tooltip@@manageViews.delete">
                            <app-icon icon="trash"></app-icon>
                        </button>
                    </div>
                </div>

                <div *ngIf="filteredViews.length === 0" class="no-results">
                    <p i18n="XMSG|No views found message@@manageViews.noResults">No views match your search.</p>
                </div>
            </div>
        </div>
    </div>
</ng-template>
